import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

type AIButtonProps = {
  onClick?: () => void;
  mobile?: boolean;
};

export default function AIButton({
  onClick,
  mobile = false
}: AIButtonProps) {

    const { t } = useTranslation();

  /*
  =========================
  MOBILE FLOATING BUTTON
  =========================
  */

  /*if (mobile) {

    return (

      <button
        onClick={onClick}
        className="
          absolute
          bottom-24
          right-4
          z-50

          flex
          items-center
          justify-center

          w-14
          h-14

          rounded-full

          bg-gradient-to-r
          from-violet-600
          to-indigo-500

          text-white

          shadow-xl
          shadow-violet-500/30

          active:scale-95
          transition-all
        "
      >

        <Sparkles size={24} />

      </button>

    );

  }*/

  /*
  =========================
  DESKTOP BUTTON
  =========================
  */

  return (

    <button
      onClick={onClick}
      className="
        relative h-auto inline-flex items-center justify-center
        gap-2

        px-3
        py-1

        rounded-full

        bg-gradient-to-r
        from-violet-600
        to-indigo-500

        text-white
        font-semibold
        text-sm

        shadow-lg
        shadow-violet-500/20

        hover:scale-[1.02]
        hover:shadow-xl

        active:scale-[0.98]

        transition-all
      "
    >

      <Sparkles
        size={18}
        className="
          group-hover:rotate-12
          transition-transform
        "
      />

      <>
        <span className="hidden sm:inline">
            {t('assistantIA2')}
        </span>

        <span className="sm:hidden">
            IA
        </span>
        </>

    </button>

  );

}